<template>
    <div class="searchTicket" @click="getTicketInfo(ticket.goods_id)">
        <h2>{{this.ticket.goods_name}}</h2>
        <div class="s_content">
            <div class="search_img">
                <img :src="this.weburl +this.ticket.original_img" alt="">
            </div>
            <div class="search_word">
                <p>{{ticket.keywords.replace(',','&nbsp;&nbsp;')}}</p>
                 <p class="s_price"><i>￥{{ticket.shop_price}}</i> <s>￥{{this.ticket.market_price}}</s></p>
            </div>
        </div>
        <span>{{$t('nav.online')}}</span>
    </div>
</template>

<script>
    export default {
        name: "searchTicket",
        props:['ticket'],
        methods:{
            getTicketInfo(id){
                this.$router.push({
                    path: `/ticketDetail/${id}`,
                })
            }
        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/search";
    .searchTicket {
        .s_layout;
        .s_content {
            height: 72px;
            width: @width;
            .search_word {
                p:first-child {
                    overflow: hidden;
                    text-overflow:ellipsis;//文本溢出显示省略号
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical
                }
                height: @width;
                position: relative;
                p.s_price {
                    position: absolute;
                    bottom: 0;
                    left:0;
                    i {
                        color:@color;
                        font-size: @font + .1;
                        position: relative;
                        margin-right: 20px;
                        &:after {
                            content: '起';
                            font-size: .6rem;
                        }
                    }
                    s {
                        color:@word;
                        font-size: .6rem;
                    }
                }
            }

        }
    }

</style>
